<template>
  <div id="bar-chart" class="echarts">
    <VueApexCharts
      type="bar"
      :options="options"
      :series="series"
      :height="height"
    >
    </VueApexCharts>
    <h3 v-if="args.graphTitle != null">{{ args.graphTitle }}</h3>
  </div>
</template>

<script >
import VueApexCharts from "vue-apexcharts";
import { sync } from "vuex-pathify";
import ui from "@/../../coreui/helpers/ui";
import apexChartsMixin from "@/../../coreui/mixins/apexChartsMixin";

export default {
  props: ["args"],
  mixins: [apexChartsMixin],
  components: {
    VueApexCharts,
  },
  watch: {
    args: {
      immediate: true,
      deep: true,
      handler(val) {
				this.series = val.values
				this.height = "100%"
				// console.log('original values length ', val.values)
        // this.series = this.fullScreen ? val.values.slice(0,19) : val.values.slice(0,5)
				// console.log('truncated values length ', this.series.length)
      },
    },
    dark: {
			immediate: true,
      handler(val, old) {
        if (val == old) { return }
        this.options = { ...this.options, ...{
					theme: {
						mode: val ? "dark" : "light",
						palette:  val ? this.args.palette_dark : this.args.palette_light,
					}
          // stroke: {
          //   width: 4,
          //   colors: [ui.theme(val).lighterbg],
          // },
        }}
      },
    },
		fullScreen (val) {
			// console.log('fullScreen: ', val)
			// this.height = val ? "95%" : "100%"
		}
  },
  data() {
    var self = this;
    return {
      height: "100%",
      options: {
        chart: {
          toolbar: {
            show: false
          },
          stacked: this.args.stacked != undefined ? this.args.stacked : false,
          animations: {
            enabled: true,
            easing: "linear",
            speed: 10000,
            animateGradually: { enabled: true, delay: 1000 },
            dynamicAnimation: { enabled: true, speed: 1000 },
          },
          selection: {
            enabled: true,
          },
					zoom: {
						enabled: true
					}
        },
				labels: this.args.labels,
        theme: {
          mode: this.dark ? "dark" : "light",
          palette: this.dark
            ? this.args.palette_dark
            : this.args.palette_light,
        },
        // fill: {
        //   type: "gradient",
        //   gradient: {
        //     shade: "dark",
        //     type: "horizontal",
        //     shadeIntensity: 1.0,
        //     inverseColors: false,
        //     opacityFrom: 1,
        //     opacityTo: 0.7,
        //     stops: [0, 100],
        //   },
        // },
        plotOptions: {
          bar: {
            // distributed: false,
            borderRadius: 5,
            distributed:
              this.args.stacked != undefined ? !this.args.stacked : true,
            dataLabels: {
              // position: "top", 
              // offsetY: 10,
            },
          },
        },
        legend: {
					position: 'top',
          show: this.fullScreen //false //this.args.stacked,
        },
        tooltip: {
          fillSeriesColor: false,
          custom: this.toolTipFormatter
        },
        dataLabels: {
          // background: {
          //   enabled: true,
          //   foreColor: '#f00'
          // },
          // colors: this.dark ? ['#FFFFFF'] : ['#000000'],
          // formatter: function (value) {
          //   return value == 0 ? "" : value;
          // },
          // offsetY: -20,
        },
        xaxis: {
          tickPlacement: "on",
          labels: {
            show: true,
            formatter: this.trim //this.fullScreen ? self.noTrim : self.shortTrim,
            // function (value) {
            //   return value == 0 ? "" : value;
            // },
          },
        },
      },
      series: [{ name: "t", data: [1] }],
    };
  },
  computed: {
    dark: sync("misc/dark"),
		facility: sync("login/facility"),
    fullScreen: sync("misc/fullScreen"),
    cUnit() {
      return this.args.unit == undefined ? "" : " " + this.args.unit;
    },
  },
  methods: {
    selectiveTrim(val) {
      return val.toString().substring(0, 8);
    },
    shortTrim(val) {
			if (val == null || val == undefined) return ''
			if (val.length < 9) return val
      return val.toString().substring(0, 8) + '...';
    },
    noTrim(val) {
      return val;
    },
    trim(v) {
      if (v == null || v ==undefined) return ""
			v = v.toString()
      let ll = 12;
      if (v.length <= ll + 3) return v;
      // var lx = ll - 3;
      return this.fullScreen ? v : v.substring(0, 7) + "..." + v.slice(-4);
    },
    toolTipFormatter({ series, seriesIndex, dataPointIndex, w }) {
			// console.log(series, seriesIndex, dataPointIndex, w)
			let stackName = w.config.series[seriesIndex].name
      return  '<div class="arrow_box">' +  this.args.labels[dataPointIndex] + "<br/>" + stackName + " : " + series[seriesIndex][dataPointIndex] + "</div>"
    },
    legendFormatter(val) {
			return val
      // str.substring(0, str.indexOf(' '))
      // return this.fullScreen ? val : this.trim(val); //val.substring(0, val.indexOf(" "));
    },
  },
  beforeMount() {},
  mounted() {},
  created() {},
  destroyed() {},
};

</script>

<style scoped>
.arrow_box {
  border: 2px solid;
  padding: 5px;
}
.echarts {
  width: 100%;
  height: 100%;
}
#bar-chart {
}
/* .apexcharts-tooltip {
  white-space: pre-wrap !important;
  max-width: 100px;
} */
</style>